import React from "react";
import styles from "./index.module.scss";
import classNames from "classnames";
import Image, { type StaticImageData } from "next/image";
import type { BridgeScannerFilterStoreType } from "@/features/bridge-scanner/stores/filters.store";
import type { BSFilterParamEnum } from "@/types/bridge-scanner.types";
import BlessCheckbox from "@/features/mod-perms/components/checkbox/checkbox";

export interface Option {
  icon?: StaticImageData;
  label: string;
  value: string;
}

interface Props {
  option: Option;
  selectedOptions?: string[] | undefined;
  selectOption: BridgeScannerFilterStoreType["setQueryParams"];
  filterType: BSFilterParamEnum;
}

const FilterOption = ({
  option,
  selectOption,
  selectedOptions,
  filterType,
}: Props) => {
  const isChecked = selectedOptions?.includes(option.value || "");

  return (
    <button
      className={classNames(styles.option, isChecked && styles.selected)}
      onClick={() => selectOption(filterType, option.value || "")}
    >
      {option.icon && (
        <div className={styles.iconContainer}>
          <Image
            className={styles.icon}
            src={option.icon}
            width={50}
            height={50}
            alt={option.label}
          />
        </div>
      )}
      <div className={styles.name}>{option.label}</div>
      <div className={styles.checkbox}>
        <BlessCheckbox checked={isChecked} />
      </div>
    </button>
  );
};

export default FilterOption;
